/* eslint-disable react-hooks/exhaustive-deps */
import { useAuth0 } from '@auth0/auth0-react'
import React, { useEffect, useState } from 'react'
import { ItineraryActivity, ItineraryFull, UserProfile } from '../../atom/Types';
import classes from './ShoppingCart.module.scss'
import Close from '@mui/icons-material/Close'
import { BedSvg, CalendarSvg, ClassSvg, ClockSvg, CountryFlagSvg, DangerCircleSvg, DeleteSvg, DoorSvg, DownSvg, DriverSvg, DurationSvg, FeetSvg, FlagSvg, InsSvg, MapSvg, PersonSvg, SmallTrainSvg, StarSvg, UpArrowSvg } from '../../constants/resources';
import moment from 'moment';
import cx from "classnames";
import ReactGA from 'react-ga4';
import { checkSpacing, keyExistInObject, Time } from '../../atom/utilities/function';
import { useSelector } from 'react-redux';
import { RootState } from '../../App';
import SuccessPage from './successPage';
import Loader from './Common/Loader';
import cartLogo from '../../asset/cart.jpg'
import DeleteModal from '../../atom/DeleteModal';
import { Tooltip } from 'react-tooltip';
import Helper from '../../Helper';

interface props {
    setShowCart: React.Dispatch<React.SetStateAction<boolean>>
    ItineraryData: ItineraryFull
}

const ShoppingCartModal: React.FC<props> = ({ setShowCart, ItineraryData }) => {
    const { isAuthenticated } = useAuth0()
    const [showDetail, setShowDetail] = useState<string>('');
    const [modal, setModal] = useState<string>('');
    const [modals, setModals] = useState(false)
    const [successEmail, setSuccessEmail] = useState<string>('')
    const [cart, setCart] = useState<ItineraryActivity[]>([]);
    const [loading, setLoading] = useState(true);
    const { Profile } = useSelector((state: RootState) => state?.Question);



    useEffect(() => {
        setLoading(true)
        let cartItem = localStorage.getItem(ItineraryData?.queryItinerary[0]?.key)
        if (cartItem !== null) {
            setCart(JSON.parse(cartItem))
            setLoading(false)
        }
        else {
            setCart([])
            setLoading(false)
        }
    }, [])

    const handleDetails = (id: string) => {
        if (showDetail === id)
            setShowDetail('')
        else
            setShowDetail(id)
    }

    const Maps = (node: any, place: any) => {
        ReactGA.event({
            category: 'Map',
            action: `Clicked Map ${place}`,

        });
        window.open("https://www.google.com/maps/search/" + node);
    }
    const handleFlightPrice = (fli: any) => {
        let price: number = 0
        if (fli.connectionFlights.length > 0) {
            fli.connectionFlights.forEach((n: any) => {
                price += n.publishedPrice
            })
        }
        price += fli.publishedPrice
        return price
    }

    const handlePrice = () => {
        let price: number = 0
        cart.forEach((element: any) => {
            if (element?.payNow !== null && element?.payNow > 0) {
                price = price + (element.payNow)
            }
            else if (element?.connectionFlights?.length > 0) {
                element.connectionFlights.forEach((n: any) => {
                    price += n.publishedPrice
                })
                price += element.publishedPrice
            }
            else {
                price = price + (element.publishedPrice)
            }
        });
        return `$ ${price}`
    }

    const handleDelete = (id: string) => {

        let copyCart = [...cart]
        let index = copyCart.findIndex((n) => { return n.id === id })
        if (index > -1)
            copyCart.splice(index, 1)
        localStorage.setItem(ItineraryData.queryItinerary[0].key, JSON.stringify(copyCart))
        setCart(copyCart)
        setModal('')
    }

    const handleViewCart = () => {
        setModals(true)
        if (isAuthenticated && (ItineraryData?.queryItinerary[0]?.travelAnswer?.email?.toLowerCase() === keyExistInObject(Profile as UserProfile, "email").toString().toLowerCase() ||
            ItineraryData?.queryItinerary[0]?.travelAnswer?.sharedEmails?.map(e => e.toLowerCase()).includes(keyExistInObject(Profile as UserProfile, "email").toString().toLowerCase()))) {
            setModals(false)
            window.location.assign(`${ItineraryData?.queryItinerary[0]?.key}/cart`)
        }
        else if (isAuthenticated && (ItineraryData?.queryItinerary[0]?.travelAnswer?.email !== keyExistInObject(Profile as UserProfile, "email") && !ItineraryData?.queryItinerary[0]?.travelAnswer?.sharedEmails?.includes(keyExistInObject(Profile as UserProfile, "email").toString()))) {
            setSuccessEmail('misMatch')
        }
        else {
            setSuccessEmail('notLogged')
        }
    }

    return (
        <>
            {cart.length > 0 && !loading ?
                <div className={classes.cartContent}>
                    <div className={classes.cart} style={{ justifyContent: 'space-between' }}><p className={classes.poppins} >Cart <span className={classes.hanken}>{cart.length} items</span></p>
                        <button className={classes.CloseButton} onClick={() => { setShowCart(false) }}>
                            <Close className={classes.closesvg} />
                        </button>
                    </div>
                    <div style={{ maxHeight: 'calc(712px - 312px)', overflowY: 'auto', height: 'fit-content' }}>
                        {cart.map((items: any) => {
                            return items.type === 'activity' ? <div className={classes.details} >
                                <div className={classes.headModal}>
                                    <p className={classes.poppins} style={{ textAlign: 'left', minWidth: '250px', fontSize: '16px' }}>{items.activity.name}</p>
                                    <div className={classes.tittle}>
                                        <div style={{ cursor: 'pointer' }} onClick={() => setModal(items.id)}>
                                            <DeleteSvg />
                                        </div>

                                    </div>
                                </div>
                                <div className={classes.priceBox}>
                                    <div className={classes.headModal}>
                                        <p className={classes.hanken1} style={{ fontSize: '12px', color: '#545D68' }}>Full Tour Price</p>
                                        <p className={items.payNow !== null && items.payNow > 0 ? classes.span1 : classes.poppins1}>{items.payNow !== null && items.payNow > 0 && <span data-tooltip-id="my-tooltip" data-tooltip-content="You’ll have to pay the rest of a Full Tour Price at a location!"> <DangerCircleSvg /></span>}${items.publishedPrice}</p>
                                        <Tooltip id="my-tooltip"
                                            className={classes.tooltip}
                                        />
                                    </div>
                                    {items.payNow !== null && items.payNow > 0 &&
                                        <>
                                            <hr style={{ width: '100%' }} />
                                            <div className={classes.headModal}>
                                                <p className={classes.hanken1} style={{ fontSize: '12px', color: '#545D68' }}>Pay Now</p>
                                                <p className={classes.poppins} style={{ fontSize: '16px', color: '#0279CF' }}>${items.payNow}</p>
                                            </div>
                                        </>}
                                </div>
                                <hr style={{ width: '100%' }} />
                                <div className={classes.details} style={{ padding: '0px' }}>
                                    <p style={{ alignItems: 'center', cursor: 'pointer' }} onClick={() => handleDetails(items.id)} className={classes.hanken2}>{showDetail === items.id ? 'Hide Details' : 'Show Details'} <span>{showDetail === items.id ? <DownSvg rotate={'rotate(180deg)'} /> : <DownSvg rotate={'rotate(0deg)'} />}</span></p>
                                    {showDetail === items.id &&
                                        <div className={classes.detailDesc}>
                                            <div className={classes.grid1}>
                                                <div className={cx(classes.gridDetails, classes.hanken1)}>
                                                    <CalendarSvg width={"16"} height={"16px"} color={"#273443"} />
                                                    <p>Date:</p>
                                                    <p>{moment.utc(items?.date).format('dddd, MMMM D, YYYY')}</p>
                                                </div>
                                                <div className={cx(classes.gridDetails, classes.hanken1)}>
                                                    <ClockSvg />
                                                    <p>Start Time:</p>
                                                    <p>{Helper.TimeConverter(items?.departureTime)}</p>
                                                </div>
                                                <div className={cx(classes.gridDetails, classes.hanken1)}>
                                                    <DurationSvg />
                                                    <p>Duration:</p>
                                                    <p>{Helper.convertDecimalTime(items.durationHours)}</p>
                                                </div>
                                            </div>
                                            <div className={classes.grid1} >
                                                <div className={cx(classes.gridDetails, classes.hanken1)} style={{ alignItems: 'start', cursor: 'pointer' }} onClick={() => Maps(items.meetingPointInfo, 'Meeting and pickup')}>
                                                    <FlagSvg />
                                                    <p style={{ maxWidth: '300px' }}>Meeting and pickup: {items.meetingPointInfo}</p>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div> : items.type === 'insurances' ? <div className={classes.details}>
                                <div className={classes.headModal}>
                                    <p className={classes.poppins} style={{ textAlign: 'left', minWidth: '250px', fontSize: '16px' }}>{items.insurance.plan}</p>
                                    <div className={classes.tittle}>
                                        <div style={{ cursor: 'pointer' }} onClick={() => setModal(items.id)}>
                                            <DeleteSvg />
                                        </div>

                                    </div>
                                </div>
                                <div className={classes.priceBox}>
                                    <div className={classes.headModal}>
                                        <p className={classes.hanken1} style={{ fontSize: '12px', color: '#545D68' }}>Total Price</p>
                                        <p className={classes.poppins1}>${items.publishedPrice}</p>
                                    </div>
                                </div>
                                <div className={classes.insContent}>
                                    <button style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><CountryFlagSvg />{items.insurance.state}</button>
                                    <button style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><InsSvg />{items.insurance.provider}</button>
                                </div>
                            </div> : items.type === 'train' ?
                                <div className={classes.details}>
                                    <div className={classes.headModal}>
                                        <p className={classes.poppins} style={{ textAlign: 'left', minWidth: '250px', fontSize: '16px' }}>{items.train.trainCompany}</p>
                                        <div className={classes.tittle}>
                                            <div style={{ cursor: 'pointer' }} onClick={() => setModal(items.id)}>
                                                <DeleteSvg />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={classes.priceBox}>
                                        <div className={classes.headModal}>
                                            <p className={classes.hanken1} style={{ fontSize: '12px', color: '#545D68' }}>Total Price</p>
                                            <p className={classes.poppins1}>${items.publishedPrice}</p>
                                        </div>
                                    </div>
                                    <div className={classes.details} style={{ padding: '0px' }}>
                                        <p style={{ alignItems: 'center', cursor: 'pointer' }} onClick={() => handleDetails(items.id)} className={classes.hanken2}>{showDetail === items.id ? 'Hide Details' : 'Show Details'} <span>{showDetail === items.id ? <DownSvg rotate={'rotate(180deg)'} /> : <DownSvg rotate={'rotate(0deg)'} />}</span></p>
                                        {showDetail === items.id &&
                                            <div className={classes.detailDesc}>
                                                <div className={classes.grid1}>
                                                    <div className={cx(classes.gridDetails, classes.hanken1)}>
                                                        <p>Train Number:</p>
                                                        <p>{items?.trainNumber}</p>
                                                    </div>
                                                    <div className={cx(classes.gridDetails, classes.hanken1)}>
                                                        <StarSvg />
                                                        <p>Operator:</p>
                                                        <p>{items?.train?.trainCompany}</p>
                                                    </div>
                                                    <div className={cx(classes.gridDetails, classes.hanken1)}>
                                                        <UpArrowSvg />
                                                        <p>Departure Time:</p>
                                                        <p>{Time(items?.departTime)}</p>
                                                    </div>
                                                    <div className={cx(classes.gridDetails, classes.hanken1)}>
                                                        <ClassSvg />
                                                        <p>class:</p>
                                                        <p>{items?.class}</p>
                                                    </div>
                                                    <div className={cx(classes.gridDetails, classes.hanken1)}>
                                                        <UpArrowSvg rotate={'rotate(180deg)'} />
                                                        <p>Arrival Time:</p>
                                                        <p>{Time(items?.arrivalTime)}</p>
                                                    </div>
                                                    <div className={cx(classes.gridDetails, classes.hanken1)}>
                                                        <SmallTrainSvg />
                                                        <p>Train type:</p>
                                                        <p>{items?.trainType}</p>
                                                    </div>
                                                    {/* <div className={cx(classes.gridDetails, classes.hanken1)}>
                                                        <DurationSvg />
                                                        <p>Duration:</p>
                                                        <p>{convertDecimalTime(items.durationHours)}</p>
                                                    </div> */}
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div> : items.type === 'carRental' ?
                                    <div className={classes.details}>
                                        <div className={classes.headModal}>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <p className={classes.poppins} style={{ textAlign: 'left', maxWidth: '300px', fontSize: '16px' }}>Car Rental</p>
                                                <p style={{ fontWeight: 700, fontSize: '14px', color: '#758191' }}>{items?.carRental?.companyName}</p>
                                            </div>
                                            <div className={classes.tittle}>
                                                <div style={{ cursor: 'pointer' }} onClick={() => setModal(items.id)}>
                                                    <DeleteSvg />
                                                </div>
                                            </div>
                                        </div>
                                        <div className={classes.insContent}>
                                            <button style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{items?.carBrand}</button>
                                            <button style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{items?.carType}</button>
                                            <button style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{items?.carAmenities[0]}</button>
                                        </div>
                                        <div className={classes.priceBox}>
                                            <div className={classes.headModal}>
                                                <p className={classes.hanken1} style={{ fontSize: '12px', color: '#545D68' }}>Full Property Price</p>
                                                <p className={classes.poppins2}>{items.payNow !== null && items.payNow > 0 && <span data-tooltip-id="my-tooltip" data-tooltip-content="You’ll have to pay the rest of a Full Property Price at a location!"> <DangerCircleSvg /></span>} ${items.publishedPrice}</p>
                                                <Tooltip id="my-tooltip"
                                                    className={classes.tooltip}
                                                />
                                            </div>
                                            {items.payNow !== null && <hr />}
                                            {items.payNow !== null && <div className={classes.headModal}>
                                                <p className={classes.hanken1} style={{ fontSize: '12px', color: '#545D68' }}>Pay Now</p>
                                                <p className={classes.poppins1} style={{ fontSize: '16px' }}>${items.payNow}</p>
                                            </div>}
                                        </div>
                                        <div className={classes.details} style={{ padding: '0px' }}>
                                            <p style={{ alignItems: 'center', cursor: 'pointer' }} onClick={() => handleDetails(items.id)} className={classes.hanken2}>{showDetail === items.id ? 'Hide Details' : 'Show Details'} <span>{showDetail === items.id ? <DownSvg rotate={'rotate(180deg)'} /> : <DownSvg rotate={'rotate(0deg)'} />}</span></p>
                                            {showDetail === items.id &&
                                                <div className={classes.detailDesc}>
                                                    <div className={classes.grid1}>
                                                        <div className={cx(classes.gridDetails, classes.hanken1)}>
                                                            <p>Paying Arrangement: </p>
                                                            <p>{items?.payingArrangement}</p>
                                                        </div>
                                                        <div className={cx(classes.gridDetails, classes.hanken1)}>
                                                            <p>Cancellation Policy: </p>
                                                            <p>{items?.cancellationPolicy}</p>
                                                        </div>
                                                        <div className={cx(classes.gridDetails, classes.hanken1)}>
                                                            <p><DriverSvg /></p>
                                                            <p>Driver :</p>
                                                            <p>{items.driver.firstname} {items.driver.lastname}</p>
                                                        </div>
                                                        <div className={cx(classes.gridDetails, classes.hanken1)}>
                                                            <p><PersonSvg /></p>
                                                            <p>Passengers : </p>
                                                            <p>{items?.passengerCount}</p>
                                                        </div>
                                                        <div className={cx(classes.gridDetails, classes.hanken1)}>
                                                            <p><DoorSvg /></p>
                                                            <p>Doors :</p>
                                                            <p>{items.doorCount}</p>
                                                        </div>
                                                        <div className={cx(classes.gridDetails, classes.hanken1)}>
                                                            <p><UpArrowSvg /></p>
                                                            <p>Pick up : {items.pickUpLocation} ,{moment.utc(items?.pickUpDate).format('dddd, MMMM D')} ,{Time(items.pickUpTime)}</p>
                                                        </div>
                                                        <div className={cx(classes.gridDetails, classes.hanken1)}>
                                                            <UpArrowSvg rotate={'rotate(180deg)'} />
                                                            <p>Drop off : {items.dropOffLocation}, {moment.utc(items?.dropOffDate).format('dddd, MMMM D')} ,{Time(items.dropOffTime)}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div> : items.type === 'accommodation' ?
                                        <div className={classes.details}>
                                            <div className={classes.headModal}>
                                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                    <p className={classes.poppins} style={{ textAlign: 'left', maxWidth: '300px', fontSize: '16px' }}>{items.roomDetails[0].roomDetail.name}</p>
                                                    <p style={{ fontWeight: 700, fontSize: '14px', color: '#758191' }}>{items.accommodation.name}</p>
                                                </div>
                                                <div className={classes.tittle}>
                                                    <div style={{ cursor: 'pointer' }} onClick={() => setModal(items.id)}>
                                                        <DeleteSvg />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={classes.insContent}>
                                                <button style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{items.accommodation.numberOfStars}-Star</button>
                                                {items.accommodation.adultsOnly && <button style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>Adults Only</button>}
                                            </div>
                                            <div className={classes.priceBox}>
                                                <div className={classes.headModal}>
                                                    <p className={classes.hanken1} style={{ fontSize: '12px', color: '#545D68' }}>Full Property Price</p>
                                                    <p className={classes.poppins2}>{items.payNow !== null && items.payNow > 0 && <span data-tooltip-id="my-tooltip" data-tooltip-content="You’ll have to pay the rest of a Full Property Price at a location!"> <DangerCircleSvg /></span>} ${items.publishedPrice}</p>
                                                    <Tooltip id="my-tooltip"
                                                        className={classes.tooltip}
                                                    />
                                                </div>
                                                {items.payNow !== null && <hr />}
                                                {items.payNow !== null && <div className={classes.headModal}>
                                                    <p className={classes.hanken1} style={{ fontSize: '12px', color: '#545D68' }}>Pay Now</p>
                                                    <p className={classes.poppins1} style={{ fontSize: '16px' }}>${items.payNow}</p>
                                                </div>}
                                            </div>
                                            <div className={classes.details} style={{ padding: '0px' }}>
                                                <p style={{ alignItems: 'center', cursor: 'pointer' }} onClick={() => handleDetails(items.id)} className={classes.hanken2}>{showDetail === items.id ? 'Hide Details' : 'Show Details'} <span>{showDetail === items.id ? <DownSvg rotate={'rotate(180deg)'} /> : <DownSvg rotate={'rotate(0deg)'} />}</span></p>
                                                {showDetail === items.id &&
                                                    <div className={classes.detailDesc}>
                                                        <div className={classes.grid1}>
                                                            <div className={cx(classes.gridDetails, classes.hanken1)}>
                                                                <p><PersonSvg /></p>
                                                                <p>Sleeps {items.roomDetails[0].roomDetail.maxOccupancy}</p>
                                                            </div>
                                                            <div className={cx(classes.gridDetails, classes.hanken1)}>
                                                                <p> <BedSvg /></p>
                                                                <p>{items.roomDetails[0].roomDetail.beds}</p>
                                                            </div>
                                                            <div className={cx(classes.gridDetails, classes.hanken1)}>
                                                                <p><FeetSvg /></p>
                                                                <p>{items.roomDetails[0].roomDetail.size}</p>
                                                            </div>
                                                            <div className={cx(classes.gridDetails, classes.hanken1)}>
                                                                <p><MapSvg /></p>
                                                                <p>{items.accommodation.locality}</p>
                                                            </div>
                                                            <div className={cx(classes.gridDetails, classes.hanken1)}>
                                                                <p><PersonSvg /></p>
                                                                <p>{items.persons.length} persons</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            <div className={classes.priceBox}>
                                                <div className={classes.headModal} style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                                                    <p className={classes.hanken1} style={{ fontSize: '12px', color: '#758191' }}>Comment</p>
                                                    <p className={classes.hanken1} style={{ color: '#273443' }}>{checkSpacing(items.comment) ? items.comment : 'no comment'}</p>
                                                </div>
                                            </div>
                                        </div> : items.__typename === "ItineraryFlight" ? <div className={classes.details}>
                                            <div className={classes.headModal}>
                                                <p className={classes.poppins} style={{ textAlign: 'left', minWidth: '250px', fontSize: '16px' }}>{items.flight.airlineName},{items.flight.departure.airportCode ? items.flight.departure.airportCode : items.flight.departureAirportCode}-{items.connectionFlights?.length > 0 ? items.connectionFlights[items.connectionFlights.length - 1]?.flight?.arrival?.airportCode ? items.connectionFlights[items.connectionFlights.length - 1].flight?.arrival?.airportCode : items.connectionFlights[items.connectionFlights.length - 1].flightarrivalAirportCode : items.flight.arrival.airportCode ? items.flight.arrival.airportCode : items.flight.arrivalAirportCode}</p>
                                                <div className={classes.tittle}>
                                                    <div style={{ cursor: 'pointer' }} onClick={() => setModal(items.id)}>
                                                        <DeleteSvg />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={classes.priceBox}>
                                                <div className={classes.headModal}>
                                                    <p className={classes.hanken1} style={{ fontSize: '12px', color: '#545D68' }}>Total Price</p>
                                                    <p className={classes.poppins1}>${handleFlightPrice(items)}</p>
                                                </div>
                                            </div></div> : null
                        })}
                    </div>
                    <div style={{ display: 'flex', gap: '5px', flexDirection: 'column', height: '124px', padding: '16px', borderTop: '1px solid #E0E6ED' }}>
                        <div className={classes.cart} style={{ justifyContent: 'space-between', alignItems: 'center' }}><p className={classes.hanken} >Subtotal</p>
                            <p className={classes.poppins} >{handlePrice()}</p>
                        </div>
                        <div className={classes.cart} style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                            <button className={classes.bottomSelectButton} onClick={() => handleViewCart()}>View Cart</button>
                            <button className={classes.bottomButton} onClick={() => handleViewCart()}>Checkout</button>
                        </div>
                    </div>

                </div> : cart.length === 0 && !loading ?

                    <div className={classes.cartContent}>
                        <div className={classes.cart} style={{ justifyContent: 'flex-end' }}>
                            <button className={classes.CloseButton} onClick={() => { setShowCart(false) }}>
                                <Close className={classes.closesvg} />
                            </button>
                        </div>
                        <div style={{ width: 'fit-Content' }}><img src={cartLogo} width={320} height={250} alt='cart' /></div>
                        <div className={classes.emptyCart}>
                            <p className={classes.cartHead}>Your Cart is empty</p>

                            <p>You have no items in your Itinerary cart. Let's go add something!</p>
                            {/* <button className={classes.checkoutbutton} onClick={() => handleNavigate()}>Go to Itineray</button> */}
                        </div>

                    </div>
                    : <Loader content='Loading...' />}
            {
                modals ? <SuccessPage successEmail={successEmail} setModal={setModals} buliddata={ItineraryData?.queryItinerary[0]} /> : null

            }
            {modal !== '' && <DeleteModal setModal={setModal} modal={modal} handleDelete={handleDelete} />}
        </>
    )
}

export default ShoppingCartModal